import { render, staticRenderFns } from "./ContactGroupAdd.vue?vue&type=template&id=085d1e9a&scoped=true&"
import script from "./ContactGroupAdd.vue?vue&type=script&lang=js&"
export * from "./ContactGroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d1e9a",
  null
  
)

export default component.exports